import { aboutUsEnumsArr, contactEnumsArr } from "../config";

export const EMPTY_TAB_DISPLAY_NAMES = {
  ABOUT_US: "Our Purpose",
  OUR_STORY: "Our Story",
  OUR_TEAM: "Our Team",
  OUR_CLIENT: "Our Clients",
  ACCREDITATIONS_AWARDS: "Our Accreditations",
  OUR_SUPPORTERS: "Our Supporters",
  SALES: "Sales",
  HUMAN_RESOURCE: "Careers",
  EXPERIENCES_OF_WORK: "Experiences of work",
  REVIEWS: "Reviews",
  SOCIAL_MEDIA: "Social media",
  ADDRESS: "Addresses",
  GETTING_TO_US: "Getting to us",
  CUSTOMER_SERVICES: "Customer services",
  CONTRACTS: "Contracts",
  VOLUNTEERING: "Volunteering",
  PART_TIME: "Apprenticeships",
  FULL_TIME: "Vacancies",
  businessCard: "Business Card",
  corousel: "Home carousel",
  "about-us": "About Us",
  product: "Products",
  service: "Services",
  contract: "Contracts",
  "contact-us": "Contact Us",
  courses: "Courses",
  events: "Events",
  "why-work": "Why work for us",
  "teams-and-roles": "Our teams and roles",
  "work-experience": "Experiences of work",
  news_tab: "Blog",
  press: "In The Press",
};

export const getEmptyTabWarningMessage = (tabName) =>
  `Warning: Please fill in all mandatory information. After that, the ${tabName} tab will be displayed on the published site.`;

export const isEmptyTabApiResponse = (status, data) =>
  status === 200 && Array.isArray(data) && data.length === 0;

export const shouldShowEmptyTabWarning = ({ isPublished, status, data }) =>
  Boolean(isPublished) && isEmptyTabApiResponse(status, data);

export const getEmptyTabDisplayName = (tabKey, fallbackName) => {
  const isSubTab =
    aboutUsEnumsArr.includes(tabKey) || contactEnumsArr.includes(tabKey);
  if (isSubTab) {
    return EMPTY_TAB_DISPLAY_NAMES[tabKey] || fallbackName || tabKey;
  }
  return fallbackName || EMPTY_TAB_DISPLAY_NAMES[tabKey] || tabKey;
};

export const resolveTabDataFromStore = (tabData, tabKey) => {
  if (!tabData || !tabKey) return undefined;
  if (Object.prototype.hasOwnProperty.call(tabData, tabKey)) {
    return tabData[tabKey];
  }
  const transformed = String(tabKey).toUpperCase().replace("-", "_");
  if (Object.prototype.hasOwnProperty.call(tabData, transformed)) {
    return tabData[transformed];
  }
  return undefined;
};
